import { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'

export const BREAKPOINTS = {
  desktop: '(min-width: 640px)',
  mobile: '(max-width: 639px)',
  reducedMotion: '(prefers-reduced-motion: reduce)'
}

export const useHydratedMediaQuery = (query, deviceWidth = 1600) => {
  const [hydrated, setHydrated] = useState(false)
  const hydratedQueryResult = useMediaQuery(
    { query },
    hydrated ? undefined : { deviceWidth }
  )

  useEffect(() => {
    if (hydrated) {
      return
    }

    setHydrated(true)
  }, [hydrated])

  return hydrated && hydratedQueryResult
}

export const usePrefersReducedMotion = () =>
  useHydratedMediaQuery(BREAKPOINTS.reducedMotion)

export const useDesktopBreakpoint = () =>
  useHydratedMediaQuery(BREAKPOINTS.desktop)
